export default class ProjetoCreateProjetoController {
  constructor($q, $state, $scope, AuthenticationService, AuthorizationService, UIService, ProjetoService, Projeto, ProjetoEquipa, ProjetoInstituicao, ProjetoAreaInterdisciplinar, EntidadeFinanciadora, Investigador, Instituicao, GrupoInvestigacao, AreaInterdisciplinar, Papel, ProjetoEstado, ProjetoEstadoCandidatura, ProjetoGrupoInvestigacao, Impacto, ImpactoOds, Ods, Pais) {
    this.$q = $q;
    this.state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.AuthorizationService = AuthorizationService;
    this.ProjetoService = ProjetoService;
    this.loaded = false;

    this.Projeto = Projeto;
    this.ProjetoEquipa = ProjetoEquipa;
    this.ProjetoInstituicao = ProjetoInstituicao;
    this.ProjetoAreaInterdisciplinar = ProjetoAreaInterdisciplinar;
    this.EntidadeFinanciadora = EntidadeFinanciadora;
    this.Investigador = Investigador;
    this.Instituicao = Instituicao;
    this.GrupoInvestigacao = GrupoInvestigacao;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.Papel = Papel;
    this.ProjetoEstado = ProjetoEstado;
    this.ProjetoEstadoCandidatura = ProjetoEstadoCandidatura;
    this.ProjetoGrupoInvestigacao = ProjetoGrupoInvestigacao;
    this.Impacto = Impacto;
    this.ImpactoOds = ImpactoOds;
    this.Ods = Ods;
    this.Pais = Pais;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.entidadesFinanciadoras = null;
    this.investigadores = null;
    this.papeis = null;
    this.estados = null;
    this.estadosCandidatura = null;


    this.emptyData = {
      form: 1,
      details: {},
      impacto: {ods: []},

      instituicoes: [],
      grupos: [],
      elementos: [],
      areas: [],
      auxEntidadeFinanciadora: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxPapel: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxEstado: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxEstadoCandidatura: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxInvestigador: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxCoInvestigador: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},

      auxPublicado: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxDestaque: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxAdoption: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxDifferent: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxRelevant: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxCitizen: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxPerformed: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxResource: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxInternational: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxDevelopingCountries: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},

      auxImpactoAmbiental: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoEconomico: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoSocial: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoPolicyInfluence: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}}
    };

    // Configuration for date picker data
    this.dateOptions = {
      dataCandidatura: {format: 'DD/MM/YYYY'},
      dataComunicacaoAvaliacao: {format: 'DD/MM/YYYY'},
      dataInicio: {format: 'DD/MM/YYYY'},
      dataFim: {format: 'DD/MM/YYYY'}
    };

    // Load data to fill ui-selects
    this.loadAuxData();

    $scope.$watch(() => {
      return this.data;
    }, (val) => {
      if (angular.isDefined(val)) {
        localStorage.setItem('ISR_SGI_ProjetoNewForm', JSON.stringify(val));
      }
    }, true);
  }

  loadAuxData = () => {
    this.EntidadeFinanciadora.find({}).$promise.then((entidadesFinanciadoras) => {
      this.entidadesFinanciadoras = entidadesFinanciadoras;
      this.Investigador.find({}).$promise.then((investigadores) => {
        investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
        this.investigadores = investigadores;
        this.Papel.find({}).$promise.then((papeis) => {
          this.papeis = papeis;
          this.ProjetoEstado.find({}).$promise.then((estados) => {
            this.estados = estados;
            this.ProjetoEstadoCandidatura.find({}).$promise.then((estadosCandidatura) => {
              this.estadosCandidatura = estadosCandidatura;
              this.loadDataFromStorage();
              this.loaded = true;
            }).catch(err => {
              console.log(err);
              this.UI.addToast("Erro ao carregar estados de candidatura de projeto. Verifique a sua ligação");
              this.state.go('app.projeto.list');
            });
          }).catch(err => {
            console.log(err);
            this.UI.addToast("Erro ao carregar estados de projeto. Verifique a sua ligação");
            this.state.go('app.projeto.list');
          });
        }).catch(err => {
          console.log(err);
          this.UI.addToast("Erro ao carregar papéis. Verifique a sua ligação");
          this.state.go('app.projeto.list');
        });
      }).catch(err => {
        console.log(err);
        this.UI.addToast("Erro ao carregar investigadores. Verifique a sua ligação");
        this.state.go('app.projeto.list');
      });
    }).catch(err => {
      console.log(err);
      this.UI.addToast("Erro ao carregar entidades. Verifique a sua ligação");
      this.state.go('app.projeto.list');
    });
  };

  // Infinite Scroll magic
  addMoreItems = (infiniteScroll) => {
    infiniteScroll.currentItems += infiniteScroll.numToAdd;
  };

  loadDataFromStorage = () => {
    if (localStorage.getItem('ISR_SGI_ProjetoNewForm')) {
      let storageData = JSON.parse(localStorage.getItem('ISR_SGI_ProjetoNewForm'));
      // Only use what is required
      this.data = {};
      if (storageData.form) this.data.form = storageData.form; else this.data.form = angular.copy(this.emptyData.form);
      if (storageData.details) this.data.details = storageData.details; else this.data.details = angular.copy(this.emptyData.details);
      if (storageData.impacto) this.data.impacto = storageData.impacto; else this.data.impacto = angular.copy(this.emptyData.impacto);

      if (storageData.instituicoes) this.data.instituicoes = storageData.instituicoes; else this.data.instituicoes = angular.copy(this.emptyData.instituicoes);
      if (storageData.grupos) this.data.grupos = storageData.grupos; else this.data.grupos = angular.copy(this.emptyData.grupos);
      if (storageData.elementos) this.data.elementos = storageData.elementos; else this.data.elementos = angular.copy(this.emptyData.elementos);
      if (storageData.areas) this.data.areas = storageData.areas; else this.data.areas = angular.copy(this.emptyData.areas);

      if (storageData.auxEntidadeFinanciadora) this.data.auxEntidadeFinanciadora = storageData.auxEntidadeFinanciadora; else this.data.auxEntidadeFinanciadora = angular.copy(this.emptyData.auxEntidadeFinanciadora);
      if (storageData.auxPapel) this.data.auxPapel = storageData.auxPapel; else this.data.auxPapel = angular.copy(this.emptyData.auxPapel);
      if (storageData.auxEstado) this.data.auxEstado = storageData.auxEstado; else this.data.auxEstado = angular.copy(this.emptyData.auxEstado);
      if (storageData.auxEstadoCandidatura) this.data.auxEstadoCandidatura = storageData.auxEstadoCandidatura; else this.data.auxEstadoCandidatura = angular.copy(this.emptyData.auxEstadoCandidatura);
      if (storageData.auxInvestigador) this.data.auxInvestigador = storageData.auxInvestigador; else this.data.auxInvestigador = angular.copy(this.emptyData.auxInvestigador);
      if (storageData.auxCoInvestigador) this.data.auxCoInvestigador = storageData.auxCoInvestigador; else this.data.auxCoInvestigador = angular.copy(this.emptyData.auxCoInvestigador);

      if (storageData.auxPublicado) this.data.auxPublicado = storageData.auxPublicado; else this.data.auxPublicado = angular.copy(this.emptyData.auxPublicado);
      if (storageData.auxDestaque) this.data.auxDestaque = storageData.auxDestaque; else this.data.auxDestaque = angular.copy(this.emptyData.auxDestaque);
      if (storageData.auxAdoption) this.data.auxAdoption = storageData.auxAdoption; else this.data.auxAdoption = angular.copy(this.emptyData.auxAdoption);
      if (storageData.auxDifferent) this.data.auxDifferent = storageData.auxDifferent; else this.data.auxDifferent = angular.copy(this.emptyData.auxDifferent);
      if (storageData.auxRelevant) this.data.auxRelevant = storageData.auxRelevant; else this.data.auxRelevant = angular.copy(this.emptyData.auxRelevant);
      if (storageData.auxCitizen) this.data.auxCitizen = storageData.auxCitizen; else this.data.auxCitizen = angular.copy(this.emptyData.auxCitizen);
      if (storageData.auxPerformed) this.data.auxPerformed = storageData.auxPerformed; else this.data.auxPerformed = angular.copy(this.emptyData.auxPerformed);
      if (storageData.auxResource) this.data.auxResource = storageData.auxResource; else this.data.auxResource = angular.copy(this.emptyData.auxResource);
      if (storageData.auxInternational) this.data.auxInternational = storageData.auxInternational; else this.data.auxInternational = angular.copy(this.emptyData.auxInternational);
      if (storageData.auxDevelopingCountries) this.data.auxDevelopingCountries = storageData.auxDevelopingCountries; else this.data.auxDevelopingCountries = angular.copy(this.emptyData.auxDevelopingCountries);

      if (storageData.auxImpactoAmbiental) this.data.auxImpactoAmbiental = storageData.auxImpactoAmbiental; else this.data.auxImpactoAmbiental = angular.copy(this.emptyData.auxImpactoAmbiental);
      if (storageData.auxImpactoEconomico) this.data.auxImpactoEconomico = storageData.auxImpactoEconomico; else this.data.auxImpactoEconomico = angular.copy(this.emptyData.auxImpactoEconomico);
      if (storageData.auxImpactoSocial) this.data.auxImpactoSocial = storageData.auxImpactoSocial; else this.data.auxImpactoSocial = angular.copy(this.emptyData.auxImpactoSocial);
      if (storageData.auxImpactoPolicyInfluence) this.data.auxImpactoPolicyInfluence = storageData.auxImpactoPolicyInfluence; else this.data.auxImpactoPolicyInfluence = angular.copy(this.emptyData.auxImpactoPolicyInfluence);
    } else {
      this.data = angular.copy(this.emptyData);
    }
    this.state.transitionTo('app.projeto.new.' + this.data.form);
  };

  setForm = num => {
    this.data.form = num;
    this.state.transitionTo('app.projeto.new.' + this.data.form);
  };

  cleanForm = () => {
    // Clean filled data
    this.data = angular.copy(this.emptyData);
    this.state.transitionTo('app.projeto.new.' + this.data.form);
  };

  submit = () => {
    this.isValid().then(() => {
      this.loaded = false;
      // Create Projeto and related data
      this.data.details.id = 0;
      this.data.details.entidadeFinanciadoraId = this.data.auxEntidadeFinanciadora.selected.id;
      this.data.details.papelId = this.data.auxPapel.selected.id;
      this.data.details.estadoId = this.data.auxEstado.selected.id;
      this.data.details.estadoCandidaturaId = this.data.auxEstadoCandidatura.selected.id;
      this.data.details.investigadorId = this.data.auxInvestigador.selected.id;
      this.data.details.coInvestigadorId = this.data.auxCoInvestigador.selected ? this.data.auxCoInvestigador.selected.id : null;

      this.data.details.publicado = this.data.auxPublicado.selected.value;
      this.data.details.emDestaque = this.data.auxDestaque.selected.value || 0;
      this.data.details.commercialAdoptions = this.data.auxAdoption.selected.value;
      this.data.details.differentInstitutionsAuthors = this.data.auxDifferent.selected.value;
      this.data.details.relevantStakeholders = this.data.auxRelevant.selected.value;
      this.data.details.citizenScienceApproach = this.data.auxCitizen.selected.value;
      this.data.details.performedPublicConsultation = this.data.auxPerformed.selected.value;
      this.data.details.resourceDeliverable = this.data.auxResource.selected.value;
      this.data.details.internationalCollaboration = this.data.auxInternational.selected.value;
      this.data.details.developingCountries = this.data.auxDevelopingCountries.selected.value;

      this.data.details.criadoPorId = this.user.id;
      this.data.details.dataCriacao = moment().format();
      this.data.details.atualizadoPorId = this.user.id;
      this.data.details.atualizadoa = moment().format();

      this.Projeto.create(this.data.details).$promise.then((projeto) => {

        // Create all Elementos
        let deferElementos = this.$q.defer();
        this.ProjetoService.createMultipleData(this.ProjetoEquipa, this.data.elementos, projeto.id, 'projetoId').then((x) => {
          deferElementos.resolve({ok: true});
        }).catch(err => {
          deferElementos.resolve({ok: false, output: 'Equipa de Investigação ISR'});
        });

        // Create all Instituições
        let deferInstituicoes = this.$q.defer();
        this.ProjetoService.createMultipleData(this.ProjetoInstituicao, this.data.instituicoes, projeto.id, 'projetoId').then((x) => {
          deferInstituicoes.resolve({ok: true});
        }).catch(err => {
          deferInstituicoes.resolve({ok: false, output: 'Outras Instituições participantes'});
        });

        // Create all Grupos Investigação
        let deferGruposInvestigacao = this.$q.defer();
        this.ProjetoService.createMultipleData(this.ProjetoGrupoInvestigacao, this.data.grupos, projeto.id, 'projetoId').then((x) => {
          deferGruposInvestigacao.resolve({ok: true});
        }).catch(err => {
          deferGruposInvestigacao.resolve({ok: false, output: 'Grupos de Investigação'});
        });

        // Create all Áreas
        let deferAreas = this.$q.defer();
        this.ProjetoService.createMultipleData(this.ProjetoAreaInterdisciplinar, this.data.areas, projeto.id, 'projetoId').then((x) => {
          deferAreas.resolve({ok: true});
        }).catch(err => {
          deferAreas.resolve({ok: false, output: 'Áreas Interdisciplinares'});
        });

        // Save Impacto
        let deferImpacto = this.$q.defer();
        this.saveImpacto(this.data.impacto, projeto, this.Projeto).then(x => {
          deferImpacto.resolve({ok: true});
        }).catch(err => {
          deferImpacto.resolve(err); // Resolve data is solved inside since it's multi-answer
        });

        let promises = [deferElementos.promise, deferInstituicoes.promise, deferGruposInvestigacao.promise, deferAreas.promise, deferImpacto.promise];

        // After all multiple data information is created/settled
        this.$q.all(promises).then((res) => {
          this.UI.addToast("Projeto criado com sucesso");

          localStorage.removeItem('ISR_SGI_ProjetoNewForm');

          let error = this.createdMultipleDataOk(res);
          if (error) {
            let errorMessage = "Projeto criado, mas ocorreram erros a inserir os seguintes dados: " + error + ". Por favor verifique e adicione-os manualmente";
            alert = this.UI.showAlert(errorMessage);
            alert.finally(() => {
              // Redirect to details view so it can be filled
              this.state.go('app.projeto.details', {id: projeto.id});
            });
          } else {
            this.state.go('app.projeto.list');
          }
        }).catch(err => { // Should never happen, since resolving everything...
          console.log(err);
          localStorage.removeItem('ISR_SGI_ProjetoNewForm');
          alert = this.UI.showAlert("Projeto criado, mas ocorreram erros a inserir alguns dados. Por favor verifique e adicione-os manualmente");
          alert.finally(() => {
            // Redirect to details view so it can be filled
            this.state.go('app.projeto.details', {id: projeto.id});
          });
        });
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao criar projeto. Verifique a ligação");
        this.loaded = true;
      });
    }).catch((x) => {
      // Nothing to do. Just fix values and resubmit...
    });
  };


  // Function called when changing Sim/Não
  // Clear <variable>Text if it becomes Não (assumes all variables have a Text field too)
  toggleOptionalData = (auxData, label) => {
    let labelText = label + 'Text';
    this.data.details[label] = auxData.selected.value;
    if (auxData.selected.value === 0) { // It was disabled, clear text
      this.data.details[labelText] = null;
    } else { // Do nothing
    }
  };

  // Check if there was an error adding multiple data, and return a string with the bad inserted data
  createdMultipleDataOk = (res) => {
    let output = '';
    if (res && res.length > 0) {
      res.forEach(r => {
        if (!r.ok) output += r.output + ", ";
      });
      // If there's data, remove trailing ", "
      if (output.length > 0)
        return output.slice(0, -2);
    }
    return output.length === 0 ? null : output;
  };


  isValid = () => {
    let validDefer = this.$q.defer();
    let v = true;

    // Check if projeto data is well defined
    // Acrónimo
    if (v && (!this.data.details.acronimo || this.data.details.acronimo.length === 0)) {
      this.UI.addToast("Acrónimo não preenchido");
      v = false;
      validDefer.reject();
    }

    // Slug
    if (v && (!this.ProjetoService.isValidSlug(this.data.details.slug))) {
      this.UI.addToast("Slug inválido, use apenas letras minúsculas, números e hífenes, sem espaços nem acentos.");
      v = false;
      validDefer.reject();
    }

    // Título
    if (v && (!this.data.details.titulo || this.data.details.titulo.length === 0)) {
      this.UI.addToast("Título não preenchido");
      v = false;
      validDefer.reject();
    }

    // Data de Candidatura - Se preenchida
    if (v && (this.data.details.dataCandidatura && !moment(this.data.details.dataCandidatura).isValid())) {
      this.UI.addToast("Data de Candidatura inválida");
      v = false;
      validDefer.reject();
    }
    // Data de Comunicação da Avaliação - Se preenchida
    if (v && (this.data.details.dataComunicacaoAvaliacao && !moment(this.data.details.dataComunicacaoAvaliacao).isValid())) {
      this.UI.addToast("Data de Comunicação da Avaliação inválida");
      v = false;
      validDefer.reject();
    }
    // Data de Início - Se preenchida
    if (v && (this.data.details.dataInicio && !moment(this.data.details.dataInicio).isValid())) {
      this.UI.addToast("Data de Início inválida");
      v = false;
      validDefer.reject();
    }
    // Data de Fim - Se preenchida
    if (v && (this.data.details.dataFim && !moment(this.data.details.dataFim).isValid())) {
      this.UI.addToast("Data de Fim inválida");
      v = false;
      validDefer.reject();
    }

    // Orçamento Total
    if (v && (this.data.details.orcamentoTotal && isNaN(this.data.details.orcamentoTotal))) {
      this.UI.addToast("Orçamento total inválido");
      v = false;
      validDefer.reject();
    }
    // Orçamento para o ISR
    if (v && (this.data.details.orcamentoIsr && isNaN(this.data.details.orcamentoIsr))) {
      this.UI.addToast("Orçamento ISR inválido");
      v = false;
      validDefer.reject();
    }

    // Orçamento para o ISR não deve ser superior ao total
    if (v && (isNaN(this.data.details.orcamentoTotal) && isNaN(this.data.details.orcamentoIsr) && this.data.details.orcamentoTotal < this.data.details.orcamentoIsr)) {
      this.UI.addToast("Orçamento ISR não pode ser superior ao Orçamento Total");
      v = false;
      validDefer.reject();
    }

    // Financiamento
    if (v && (this.data.details.notaQuantitativa && isNaN(this.data.details.notaQuantitativa))) {
      this.UI.addToast("Nota quantitativa inválida");
      v = false;
      validDefer.reject();
    }

    // Entidade Financiadora
    if (v && (!this.data.auxEntidadeFinanciadora || !this.data.auxEntidadeFinanciadora.selected)) {
      this.UI.addToast("Entidade Financiadora inválida");
      v = false;
      validDefer.reject();
    }
    // Papel
    if (v && (!this.data.auxPapel || !this.data.auxPapel.selected)) {
      this.UI.addToast("Papel inválido");
      v = false;
      validDefer.reject();
    }
    // Estado do Projeto
    if (v && (!this.data.auxEstado || !this.data.auxEstado.selected)) {
      this.UI.addToast("Estado do projeto inválido");
      v = false;
      validDefer.reject();
    }
    // Estado da Candidatura do Projeto
    if (v && (!this.data.auxEstadoCandidatura || !this.data.auxEstadoCandidatura.selected)) {
      this.UI.addToast("Estado da candidatura do projeto inválido");
      v = false;
      validDefer.reject();
    }
    // Investigador principal
    if (v && (!this.data.auxInvestigador || !this.data.auxInvestigador.selected)) {
      this.UI.addToast("Investigador principal inválido");
      v = false;
      validDefer.reject();
    }

    // Investigador Principal e Co-Investigador principal não podem ser iguais
    if (v && (this.data.auxCoInvestigador.selected && this.data.auxCoInvestigador.selected.id === this.data.auxInvestigador.selected.id)) {
      this.UI.addToast("Investigador e co-investigadores principais não podem ser iguais");
      v = false;
      validDefer.reject();
    }

    // Publicado?
    if (v && (!this.data.auxPublicado || !this.data.auxPublicado.selected)) {
      this.UI.addToast("Para publicação no frontend - valor inválido");
      v = false;
      validDefer.reject();
    }

    // Em Destaque - May not be filled but should be 1 or 0 or undefined / null
    if (v && (!this.data.auxDestaque || (this.data.auxDestaque.selected && this.data.auxDestaque.selected.value !== 0 && this.data.auxDestaque.selected.value !== 1))) {
      this.UI.addToast("Em Destaque - valor inválido");
      v = false;
      validDefer.reject();
    }

    // Commercial Adoptions
    if (v && (!this.data.auxAdoption || !this.data.auxAdoption.selected)) {
      this.UI.addToast("Commercial Adoptions - valor inválido");
      v = false;
      validDefer.reject();
    }
    // Different institutions authors
    if (v && (!this.data.auxDifferent || !this.data.auxDifferent.selected)) {
      this.UI.addToast("Diferent institutions authors - valor inválido");
      v = false;
      validDefer.reject();
    }
    // Relevant Stakeholders
    if (v && (!this.data.auxRelevant || !this.data.auxRelevant.selected)) {
      this.UI.addToast("Relevant Stakeholders - valor inválido");
      v = false;
      validDefer.reject();
    }
    // Citizen science approach
    if (v && (!this.data.auxCitizen || !this.data.auxCitizen.selected)) {
      this.UI.addToast("Citizen science approach - valor inválido");
      v = false;
      validDefer.reject();
    }
    // Performed public consultation
    if (v && (!this.data.auxPerformed || !this.data.auxPerformed.selected)) {
      this.UI.addToast("Performed public consultation - valor inválido");
      v = false;
      validDefer.reject();
    }
    // At least one educational resource as deliverable
    if (v && (!this.data.auxResource || !this.data.auxResource.selected)) {
      this.UI.addToast("Resource as deliverable - valor inválido");
      v = false;
      validDefer.reject();
    }
    // International collaboration
    if (v && (!this.data.auxInternational || !this.data.auxInternational.selected)) {
      this.UI.addToast("International collaboration - valor inválido");
      v = false;
      validDefer.reject();
    }
    // Involves researchers from developing countries?
    if (v && (!this.data.auxDevelopingCountries || !this.data.auxDevelopingCountries.selected)) {
      this.UI.addToast("Developing Countries - valor inválido");
      v = false;
      validDefer.reject();
    }

    // Mandatory multiple data
    if (v && (this.data.elementos.length === 0)) {
      this.UI.addToast("Equipa de investigação ISR não preenchida");
      v = false;
      validDefer.reject();
    }

    if (v && (this.data.areas.length === 0)) {
      this.UI.addToast("Áreas Interdisciplinares não preenchidas");
      v = false;
      validDefer.reject();
    }

    if (v && (this.data.areas.length > 3)) {
      this.UI.addToast("Só podem ser adicionadas 3 áreas interdisciplinares");
      v = false;
      validDefer.reject();
    }

    // Check if data is unique for multiple data
    // Elementos
    let elementos = this.data.elementos.map(x => x.investigadorId);
    let elementosRepetidos = elementos.filter((x, i) => elementos.indexOf(x) !== i);
    if (v && elementosRepetidos.length > 0) {
      this.UI.addToast("Membros de equipa repetidos");
      v = false;
      validDefer.reject();
    }
    // Instituições
    let instituicoes = this.data.instituicoes.map(x => x.instituicaoId);
    let instituicoesRepetidas = instituicoes.filter((x, i) => instituicoes.indexOf(x) !== i);
    if (v && instituicoesRepetidas.length > 0) {
      this.UI.addToast("Outras entidades repetidas");
      v = false;
      validDefer.reject();
    }
    // Grupos Investigação
    let gruposInvestigacao = this.data.grupos.map(x => x.grupoInvestigacaoId);
    let gruposRepetidos = gruposInvestigacao.filter((x, i) => gruposInvestigacao.indexOf(x) !== i);
    if (v && gruposRepetidos.length > 0) {
      this.UI.addToast("Grupos de Investigação repetidos");
      v = false;
      validDefer.reject();
    }
    // Áreas Interdisciplinares
    let areas = this.data.areas.map(x => x.areaId);
    let areasRepetidas = areas.filter((x, i) => areas.indexOf(x) !== i);
    if (v && areasRepetidas.length > 0) {
      this.UI.addToast("Áreas Interdisciplinares repetidas");
      v = false;
      validDefer.reject();
    }

    // Only validate multidata if all static data is valid, otherwise no point first
    if (v) {
      // VALIDATE ASYNC DATA
      let idData = [];

      // If slug is filled, we need to check if it exists already too
      idData.push({
        field: 'slug',
        value: this.data.details.slug,
        model: this.Projeto,
        resolveOnExist: false,
        error: "Já existe este slug associado a outro projeto"
      });

      // Add multi async data to verify
      this.data.elementos.forEach(x => {
        idData.push({
          field: 'id',
          value: x.investigadorId,
          model: this.Investigador,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Investigador inexistente"
        });
      });
      this.data.instituicoes.forEach(x => {
        idData.push({
          field: 'id',
          value: x.instituicaoId,
          model: this.Instituicao,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Instituição inexistente"
        });
      });
      this.data.grupos.forEach(x => {
        idData.push({
          field: 'id',
          value: x.grupoInvestigacaoId,
          model: this.GrupoInvestigacao,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Grupo de Investigação inexistente"
        });
      });
      this.data.areas.forEach(x => {
        idData.push({
          field: 'id',
          value: x.areaId,
          model: this.AreaInterdisciplinar,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Área Interdisciplinar inexistente"
        });
      });

      let wait = this.UI.showWaiting();
      // Verify all the async data
      this.ProjetoService.validateMultiData(idData).then(x => {

        // Verify impactos
        this.verifyImpactos(this.data.impacto).then(y => {
          wait.close();
          validDefer.resolve();
        }).catch(() => {
          wait.close();
          validDefer.reject();
        });

      }).catch(() => {
        wait.close();
        validDefer.reject();
      });
    }
    return validDefer.promise;
  };


  // MULTIPLE DATA CRUDs
  // Adicionar um novo investigador para projeto
  addElemento = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.equipa.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.elemento = {};
          $scope.label = "Adicionar Membro à Equipa de Investigação";
          $scope.investigadores = investigadores;

          $scope.auxInvestigador = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.elemento) {
          let item = angular.copy(ok.elemento);
          item.investigadorId = ok.auxInvestigador.selected.id;
          item.investigador = angular.copy(ok.auxInvestigador.selected);

          this.data.elementos.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para projeto. Verifique a sua ligação");
    });
  };

  // Edita informação de equipa para projeto
  editElemento = (x) => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.equipa.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.elemento = angular.copy(x);
          $scope.label = "Editar Membro de Equipa de Investigação";
          $scope.investigadores = investigadores;

          $scope.auxInvestigador = {
            selected: $scope.elemento.investigador,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.elemento) {
          x.investigadorId = ok.auxInvestigador.selected.id;
          x.investigador = angular.copy(ok.auxInvestigador.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para projeto. Verifique a sua ligação");
    });
  };

  // Remove Elemento com índice index
  removeElemento = (index) => {
    if (index < this.data.elementos.length) {
      this.data.elementos.splice(index, 1);
    }
  };


  // Adicionar uma nova área interdisciplinar para orientação
  addArea = () => {
    // Only allow a max of 3 areas
    if (this.data.areas.length >= 3) {
      this.UI.addToast("Só é possível escolher até 3 áreas");
      return;
    }
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.area.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.area = {};
          $scope.label = "Adicionar Área Interdisciplinar";
          $scope.areas = areas;

          $scope.auxArea = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          let item = angular.copy(ok.area);

          item.areaId = ok.auxArea.selected.id;
          item.area = ok.auxArea.selected;

          this.data.areas.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas para projeto. Verifique a sua ligação");
    });

  };

  // Edita informação de área interdisciplinar para orientação
  editArea = (x) => {
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.area.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.area = angular.copy(x);
          $scope.label = "Editar Área Interdisciplinar";
          $scope.areas = areas;

          $scope.auxArea = {
            selected: $scope.area.area,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          x.areaId = ok.auxArea.selected.id;
          x.area = angular.copy(ok.auxArea.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas para projeto. Verifique a sua ligação");
    });
  };

  // Remove área interdisciplinar com índice index
  removeArea = (index) => {
    if (index < this.data.areas.length) {
      this.data.areas.splice(index, 1);
    }
  };


  // Instituições
  // Adicionar um nova instituicao para produto
  addInstituicao = () => {
    let wait = this.UI.showWaiting();
    this.Instituicao.find({}).$promise.then((instituicoes) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.instituicao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.instituicao = {};
          $scope.label = "Adicionar Instituição envolvida";
          $scope.instituicoes = instituicoes;

          $scope.auxInstituicao = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInstituicao && ok.instituicao) {
          let item = angular.copy(ok.instituicao);
          item.instituicaoId = ok.auxInstituicao.selected.id;
          item.instituicao = angular.copy(ok.auxInstituicao.selected);

          this.data.instituicoes.push(item);
        }
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler instituições. Verifique a sua ligação");
    });
  };

  // Edita informação de instituicao para projeto
  editInstituicao = (x) => {
    let wait = this.UI.showWaiting();
    this.Instituicao.find({}).$promise.then((instituicoes) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.instituicao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.instituicao = angular.copy(x);
          $scope.label = "Editar Instituição envolvida";
          $scope.instituicoes = instituicoes;

          $scope.auxInstituicao = {
            selected: $scope.instituicao.instituicao,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInstituicao && ok.instituicao) {
          // Update data without replacing the variable x (so it's still an element of the array)

          x.instituicaoId = ok.auxInstituicao.selected.id;
          x.instituicao = angular.copy(ok.auxInstituicao.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler instituições. Verifique a sua ligação");
    });
  };

  // Remove Instituição com índice index
  removeInstituicao = (index) => {
    if (index < this.data.instituicoes.length) {
      this.data.instituicoes.splice(index, 1);
    }
  };

  // Grupos Investigação
  // Adicionar um novo grupo de investigação para projeto
  addGrupoInvestigacao = () => {
    let wait = this.UI.showWaiting();
    this.GrupoInvestigacao.find({}).$promise.then((gruposInvestigacao) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.grupo.investigacao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.grupo = {};
          $scope.label = "Adicionar Grupo de Investigação";
          $scope.grupos = gruposInvestigacao;

          $scope.auxGrupoInvestigacao = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrupoInvestigacao && ok.grupo) {
          let item = angular.copy(ok.grupo);
          item.grupoInvestigacaoId = ok.auxGrupoInvestigacao.selected.id;
          item.grupo = angular.copy(ok.auxGrupoInvestigacao.selected);

          this.data.grupos.push(item);
        }
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler grupos de investigação. Verifique a sua ligação");
    });
  };

  // Edita informação de instituicao para produto
  editGrupoInvestigacao = (x) => {
    let wait = this.UI.showWaiting();
    this.GrupoInvestigacao.find({}).$promise.then((grupos) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.grupo.investigacao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.grupo = angular.copy(x);
          $scope.label = "Editar Grupo de Investigação";
          $scope.grupos = grupos;

          $scope.auxGrupoInvestigacao = {
            selected: $scope.grupo.grupo,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrupoInvestigacao && ok.grupo) {
          // Update data without replacing the variable x (so it's still an element of the array)

          x.grupoInvestigacaoId = ok.auxGrupoInvestigacao.selected.id;
          x.grupo = angular.copy(ok.auxGrupoInvestigacao.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler grupos de investigação. Verifique a sua ligação");
    });
  };

  // Remove Instituição com índice index
  removeGrupoInvestigacao = (index) => {
    if (index < this.data.grupos.length) {
      this.data.grupos.splice(index, 1);
    }
  };

  // Impactos
  // Get data to be used in impacto edit modal
  getImpactoData = (tipo) => {
    let wait;
    let defer = this.$q.defer();
    switch(tipo) {
      case 'Ambiental':
        defer.resolve(null);
        break;
      case 'Económico':
        defer.resolve(null);
        break;
      case 'ODS':
        wait = this.UI.showWaiting();
        this.Ods.find({}).$promise.then((ods) => {
          wait.close();
          defer.resolve(ods);
        }).catch((error) => {
          wait.close();
          console.log(error);
          defer.reject(error);
        });
        break;
      case 'Social':
        defer.resolve(null);
        break;
    }
    return defer.promise;
  };

  // Edit/add impacto for tipo
  editImpacto = (tipo) => {
    this.getImpactoData(tipo).then(externalData => {
      let options = {
        size: 'lg',
        template: require('./impacto.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.tipo = tipo;
          $scope.label = "Editar Impacto " + tipo;
          $scope.impacto = angular.copy(this.data.impacto);
          switch(tipo) {
            case 'Ambiental':
              $scope.simnao = this.simnao;
              $scope.auxImpactoAmbiental = angular.copy(this.data.auxImpactoAmbiental);
              break; // Nothing to do
            case 'Económico':
              $scope.simnao = this.simnao;
              $scope.auxImpactoEconomico = angular.copy(this.data.auxImpactoEconomico);
              break;
            case 'ODS':
              $scope.externalData = externalData;
              // ODS is always "add", so it always starts as empty
              $scope.auxOds = {
                selected: undefined,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              break;
            case 'Social':
              $scope.simnao = this.simnao;
              $scope.auxImpactoSocial = angular.copy(this.data.auxImpactoSocial);
              break;
          }

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        switch(tipo) {
          case 'Ambiental':
            if(ok.auxImpactoAmbiental && ok.auxImpactoAmbiental.selected.value) { // Has "Yes" selected
              this.data.auxImpactoAmbiental = angular.copy(ok.auxImpactoAmbiental);
              this.data.impacto.ambiental = ok.impacto.ambiental;
              this.UI.addToast("Impacto ambiental atualizado");
            } else { // No ambiental data is defined, delete it
              if (this.data.impacto.ambiental) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoAmbiental.selected = undefined;
                delete this.data.impacto.ambiental;
                this.UI.addToast("Impacto ambiental eliminado");
              }
            }
            break;
          case 'Económico':
            if(ok.auxImpactoEconomico && ok.auxImpactoEconomico.selected.value) { // Has "Yes" selected
              this.data.auxImpactoEconomico = angular.copy(ok.auxImpactoEconomico);
              this.data.impacto.economico = ok.impacto.economico;
              this.UI.addToast("Impacto económico atualizado");
            } else { // No economico data is defined, delete it
              if (this.data.impacto.economico) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoEconomico.selected = undefined;
                delete this.data.impacto.economico;
                this.UI.addToast("Impacto económico eliminado");
              }
            }
            break;
          case 'ODS':
            // Check repeats - Placed here instead of isValid() so it's easier to port
            let usedOds = this.data.impacto.ods.map(x => x.odsId);
            usedOds.push(ok.auxOds.selected.id);
            let odsRepetidos = usedOds.filter((x, i) => usedOds.indexOf(x) !== i);
            if (odsRepetidos.length > 0) {
              this.UI.addToast("ODS já adicionada");
            } else { // We can add it
              this.data.impacto.ods.push({
                odsId: ok.auxOds.selected.id,
                ods: { id: ok.auxOds.selected.id, designacao: ok.auxOds.selected.designacao }
              });
              this.UI.addToast("ODS adicionado com sucesso");
            }
            break;
          case 'Social':
            if(ok.auxImpactoSocial && ok.auxImpactoSocial.selected.value) { // Has "Yes" selected
              this.data.auxImpactoSocial = angular.copy(ok.auxImpactoSocial);
              this.data.impacto.social = ok.impacto.social;
              this.UI.addToast("Impacto social atualizado");
            } else { // No social data is defined, delete it
              if (this.data.impacto.social) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoSocial.selected = undefined;
                delete this.data.impacto.social;
                this.UI.addToast("Impacto social eliminado");
              }
            }
            break;
        }
      });
    }).catch(error => {
      console.log(error);
      this.UI.addToast("Não foi possível ler dados para edição. Verifique a sua ligação");
    });
  };

  // Function called when changing Sim/Não
  // Clear text if it becomes Não
  togglePolicyInfluence = () => {
    if (this.data.auxImpactoPolicyInfluence) {
      if (this.data.auxImpactoPolicyInfluence.selected.value === 0) { // It was disabled, clear text
        this.data.impacto.policyInfluence = null;
      } else { // Do nothing
      }
    }
  };

  // Returns true or false if impactos data is ok to set to database
  verifyImpactos = (impacto) => {
    let defer = this.$q.defer();
    // Ambiental - Nothing to check
    // Social - Nothing to check
    // Económico - Nothing to check

    // ODS - Verifica ODSs individuais
    let deferOds = this.$q.defer();
    if (impacto.ods && impacto.ods.length > 0) {
      let odsTasks = [];
      for (let i = 0; i < impacto.ods.length; i++) {
        let o = this.$q.defer();

        this.ProjetoService.fieldValueExists('id', impacto.ods[i].id, this.Ods).then((exists) => {
          o.resolve(exists);
        }).catch(error => {
          o.reject(error);
        });
        odsTasks.push(o.promise);
      }

      this.$q.all(odsTasks).then(x => {
        deferOds.resolve(true);
      }).catch(error => {
        deferOds.reject(error);
      });
    } else {
      deferOds.resolve(true);
    }

    this.$q.all([deferOds.promise]).then(x => {
      defer.resolve();
    }).catch(error => {
      this.UI.addToast("Não foi possível verificar dados de impactos. Verifique a ligação");
      defer.reject(error);
    });

    return defer.promise;
  };

  // Save impacto data to database, update object with impactoId of type Model
  saveImpacto = (imp, object, Model) => {
    let defer = this.$q.defer();
    let newImpacto = {
      id: 0,
      ambiental: imp.ambiental || null,
      economico: imp.economico || null,
      social: imp.social || null,
      observacoes: imp.observacoes || null,
      policyInfluence: imp.policyInfluence || null,
      criadoPorId: this.user.id,
      dataCriacao: moment().format()
    };

    this.Impacto.create(newImpacto).$promise.then((impacto) => {
      // Save impactoId to base object for reference
      object.impactoId = impacto.id;
      Model.upsert(object).$promise.then((res) => {
        defer.resolve();
        // Create all ODS
        this.ProjetoService.createMultipleData(this.ImpactoOds, imp.ods, impacto.id, 'impactoId').then(x => {
          defer.resolve();
        }).catch(error => {
          console.log(error);
          defer.reject({ok: false, output: 'Impacto - ODS'});
        });
      }).catch((error) => {
        console.log(error);
        defer.reject({ok: false, output: 'Ligação a Impacto'});
      });
    }).catch((error) => {
      console.log(error);
      defer.reject({ok: false, output: 'Impacto'});
    });

    return defer.promise;
  };

  removeImpacto = (tipo, index) => {
    switch(tipo) {
      case 'Ambiental':
        this.data.auxImpactoAmbiental.selected = undefined;
        delete this.data.impacto.ambiental;
        this.UI.addToast("Impacto ambiental eliminado");
        break;
      case 'Económico':
        this.data.auxImpactoEconomico.selected = undefined;
        delete this.data.impacto.economico;
        this.UI.addToast("Impacto económico eliminado");
        break;
      case 'ODS':
        if (index < this.data.impacto.ods.length) {
          this.data.impacto.ods.splice(index, 1);
          this.UI.addToast("Objetivo eliminado");
        }
        break;
      case 'Social':
        this.data.auxImpactoSocial.selected = undefined;
        delete this.data.impacto.social;
        this.UI.addToast("Impacto social eliminado");
        break;
    }
  };

  updateSlug = () => {
    this.data.details.slug = this.ProjetoService.stringToSlug(this.data.details.acronimo);
  };
}

ProjetoCreateProjetoController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'AuthorizationService', 'UIService', 'ProjetoService', 'Projeto', 'ProjetoEquipa', 'ProjetoInstituicao', 'ProjetoAreaInterdisciplinar', 'EntidadeFinanciadora', 'Investigador', 'Instituicao', 'GrupoInvestigacao', 'AreaInterdisciplinar', 'Papel', 'ProjetoEstado', 'ProjetoEstadoCandidatura', 'ProjetoGrupoInvestigacao', 'Impacto', 'ImpactoOds', 'Ods', 'Pais'];
